import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios'
import qs from 'qs';
import router from '../router/index'
import { Message } from 'element-ui';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: true,
    isAdmin: true,
    userInfo: null,
    labelInfo: null,
    activeLabelInfo: null,
    setdepositInfo:null,
  },
  mutations: {
    loadingStart(state) {
      state.loading = true;
    },
    loadingFinish(state) {
      state.loading = false;
    },
    handleUserInfo(state, data) {
      state.userInfo = data
      //教师
      if (data.roleCodes.indexOf("admin") === -1) {
        state.isAdmin = false
      } else {
        state.isAdmin = true
      }
    },
    handleLabelInfo(state, data) {
      state.labelInfo = data.filter(i=>i.menuType=="daily")
    },
    setActiveLabel(state, data) {
      state.activeLabelInfo = data
    },
    setdeposit(state,data) {
      state.setdepositInfo=data
    }

  },
  actions: {
    getUserInfo() {
      const paramsObj = {
        clientPackage: "com.xueduoduo.tree.pc",
        appType: "pc",
        clientVersion: "1.0",
        menuType: "front",
        userId: localStorage.getItem("treeUserId"),
      };
      return new Promise(resolve => {
        axios.get("/user/getUserInfoById", { params: paramsObj })
          .then(({ data, resultCode, msg }) => {
            if (resultCode === 200) {
              this.commit("handleUserInfo", data);
            } else {
              Message({
                message: msg,
                type: "error",
                duration: 2000,
              });
              router.push("/login");
            }
            resolve()
          });
      });
    },
    getLabelInfo({
      commit,
      state
    }) {
      return new Promise(resolve => {
        axios.post("/client-menu/getClientMenuListByFront", { schoolCode: state.userInfo.schoolCode, operatorId: state.userInfo.userId })
          .then(({ data, resultCode, msg }) => {
            if (resultCode === 200) {
              commit("handleLabelInfo", data);
            } else {
              Message({
                message: msg,
                type: "error",
                duration: 2000,
              });
            }
            resolve()
          });
      });
    }
  }
})